import * as React from 'react';
import { IItemCardProps } from 'models/itemcard';
import * as c from 'models/constants';
import { translate } from 'react-i18next';
import { IWhoToFollow } from 'models/whotofollow';
import { imgSrcAttributes, renderFollowButton } from '../../../../helpers/common';
require('./style.css');

interface IProps extends IItemCardProps {
	item: IWhoToFollow;
	followItem?: (itemType: string, itemId: string) => void;
	unfollowItem?: (itemType: string, itemId: string) => void;
	t?: (key: string, options?: any) => string;
}
@translate(c.DEFAULT_TRANSLATION_NAMESPACE)
class OnboardingQuizFollowItemCard extends React.Component<IProps, any> {
	constructor(props) {
		super(props);

		this.followItem = this.followItem.bind(this);
		this.unfollowItem = this.unfollowItem.bind(this);
	}

	private followItem() {
		const entityIdObj: any = JSON.parse(this.props.item.entityId);
		this.props.followItem(entityIdObj.type, entityIdObj.id);
	}

	private unfollowItem() {
		const entityIdObj: any = JSON.parse(this.props.item.entityId);
		this.props.unfollowItem(entityIdObj.type, entityIdObj.id);
	}

	public render() {
		const { picture, location, name, following } = this.props.item;

		return (
			<div className="onboardingQuizFollowItemCard">
				<div>
					<img className="image" {...imgSrcAttributes(picture)} />
				</div>
				<div className="name">{name}</div>
				<div className="location">{location}</div>
				<div className="followers">{renderFollowButton(following, this.followItem, this.unfollowItem, null, null)}</div>
			</div>
		);
	}
}

export { OnboardingQuizFollowItemCard };
